'use strict';

/* global $ */

import { breakpoints } from 'settings';
// import { fancybox } from 'settings';

function SmoothScroll(options) {

  // let body = document.querySelector('.body');
  // let menu = $('.js-menu');
  $('.scroll-up').on('click',function() {

        $('html,body').animate({
            scrollTop: $('body').offset().top
        }, 500);
  });

  $(window).on('scroll', function (e){

    let pageY = window.pageYOffset || document.documentElement.scrollTop;
    let height = window.innerHeight;

      if (pageY > height/2){                
        $('.scroll-up').fadeIn(160);
      } else {
        $('.scroll-up').fadeOut(160);
      }
  });

  // $(body).on('click wheel tap',function() {
  //     if ($.fancybox.isOpen || $(menu).hasClass('is-active')) {
  //           body.classList.add('is-active');
  //       } else {
  //         body.classList.remove('is-active');
  //       }
  // });

  $('.smoothScroll').click(function() {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top
        }, 500); // The number here represents the speed of the scroll in milliseconds
        return false;
      }
    }
  });
}

export {
  SmoothScroll
};